import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { resultProfiles } from '../../data/quizData';
interface ResultData {
  id: string;
  count: number;
  percent: number;
}
interface ResultDistributionProps {
  data: ResultData[];
}
const COLORS: Record<string, string> = {
  A: '#00d4ff',
  B: '#a855f7',
  C: '#22c55e',
  D: '#f59e0b'
};
interface ResultTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: ResultData & {
      name: string;
    };
  }>;
}
function ResultTooltip({
  active,
  payload
}: ResultTooltipProps) {
  if (!active || !payload?.[0]) return null;
  const d = payload[0].payload;
  return <div className="rounded-lg border border-white/15 bg-[#0c1222]/95 backdrop-blur-md px-4 py-3 shadow-xl" data-id="element-64">
      <p className="text-sm font-bold text-white mb-1" data-id="element-65">{d.name}</p>
      <p className="text-xs text-white/60" data-id="element-66">
        Count: <span className="text-white font-medium" data-id="element-67">{d.count}</span> (
        {d.percent.toFixed(1)}%)
      </p>
    </div>;
}
export function ResultDistribution({
  data
}: ResultDistributionProps) {
  const chartData = data.map(d => {
    const profile = resultProfiles.find(p => p.id === d.id);
    return {
      ...d,
      name: profile ? `${profile.emoji} ${profile.title}` : d.id
    };
  });
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5 flex flex-col" style={{
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)'
  }} data-id="element-68">
      <h3 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4" data-id="element-69">
        Result Profiles
      </h3>

      <div className="w-full h-52" data-id="element-70">
        <ResponsiveContainer width="100%" height="100%" data-id="element-71">
          <PieChart data-id="element-72">
            <Pie data={chartData} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={3} dataKey="count" stroke="none" data-id="element-73">
              {chartData.map(entry => <Cell key={entry.id} fill={COLORS[entry.id] || '#666'} fillOpacity={0.8} data-id="element-74" />)}
            </Pie>
            <Tooltip content={<ResultTooltip data-id="element-76" />} data-id="element-75" />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className="flex flex-col gap-2.5 mt-2" data-id="element-77">
        {chartData.map(d => <div key={d.id} className="flex items-center gap-3" data-id="element-78">
            <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{
          backgroundColor: COLORS[d.id] || '#666',
          opacity: 0.8
        }} data-id="element-79" />
            <span className="text-sm text-white/60 flex-1" data-id="element-80">{d.name}</span>
            <span className="text-sm font-bold text-white/80 font-mono" data-id="element-81">
              {d.percent.toFixed(0)}%
            </span>
            <span className="text-xs text-white/30 font-mono w-8 text-right" data-id="element-82">
              {d.count}
            </span>
          </div>)}
      </div>
    </div>;
}